(() => {
function init(root) {
 if(!root || root.dataset.creatorReady)return;
 root.dataset.creatorReady='true';
(() => {
  root.querySelectorAll('.v11-video-start').forEach(button => {
    const frame = button.closest('.v10-video-frame');
    const video = frame.querySelector('video');
    const status = frame.querySelector('.v11-video-status');
    const surface = document.createElement('button');
    surface.type = 'button';
    surface.className = 'v15-video-surface';
    surface.hidden = true;
    surface.setAttribute('aria-label', 'Pause video');
    surface.innerHTML = '<span aria-hidden="true">▶</span>';
    frame.append(surface);
    const syncSurface = () => {
      surface.hidden = video.hidden;
      surface.setAttribute('aria-label', video.paused ? 'Resume video' : 'Pause video');
      surface.classList.toggle('is-paused', video.paused);
    };
    surface.addEventListener('click', () => {
      if (video.paused) video.play().catch(() => { status.hidden = false; });
      else video.pause();
    });
    let controlsTimer;
    let interacting = false;
    const fullscreen = () => video.webkitDisplayingFullscreen ||
      video.webkitPresentationMode === 'fullscreen' ||
      document.fullscreenElement === video || document.fullscreenElement === frame;
    const revealControls = () => {
      clearTimeout(controlsTimer);
      video.controls = true;
    };
    const hideControlsSoon = () => {
      revealControls();
      if (video.paused || video.ended || video.seeking || interacting || fullscreen()) return;
      controlsTimer = setTimeout(() => {
        if (!video.paused && !video.ended && !video.seeking && !interacting && !fullscreen()) {
          video.controls = false;
        }
      }, 500);
    };
    ['play', 'pause', 'ended'].forEach(event => video.addEventListener(event, syncSurface));
    ['playing', 'seeked'].forEach(event => video.addEventListener(event, hideControlsSoon));
    ['pause', 'ended', 'waiting', 'seeking', 'error'].forEach(event => video.addEventListener(event, revealControls));
    video.addEventListener('pointerdown', () => { interacting = true; revealControls(); });
    ['pointerup', 'pointercancel'].forEach(event => window.addEventListener(event, () => {
      if (!interacting) return;
      interacting = false;
      hideControlsSoon();
    }));
    video.addEventListener('click', hideControlsSoon);
    video.addEventListener('webkitbeginfullscreen', revealControls);
    video.addEventListener('webkitendfullscreen', hideControlsSoon);
    video.addEventListener('webkitpresentationmodechanged', hideControlsSoon);
    document.addEventListener('fullscreenchange', hideControlsSoon);
    video.addEventListener('keydown', event => {
      if (!video.controls && (event.key === ' ' || event.key === 'Enter')) {
        event.preventDefault();
        if (video.paused) video.play().catch(() => { status.hidden = false; });
        else video.pause();
      }
    });
    button.addEventListener('click', () => {
      status.hidden = true;
      if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
      video.hidden = false;
      syncSurface();
      button.hidden = true;
      video.play().then(() => video.focus()).catch(() => {
        button.hidden = false;
        video.hidden = true;
        syncSurface();
        status.hidden = false;
      });
    });
    video.addEventListener('error', () => {
      button.hidden = false;
      video.hidden = true;
      syncSurface();
      status.hidden = false;
    });
  });
})();

(() => {
  const track = root.querySelector('.v10-video-grid');
  if (!track) return;
  const cards = [...track.querySelectorAll('.v10-video-card')];
  const videos = cards.map(card => card.querySelector('video'));
  if (root.classList.contains('wits-pdp-videos--compact')) {
    videos.forEach(video => video.addEventListener('play', () => {
      videos.forEach(other => { if (other !== video) other.pause(); });
    }));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach(video => video.pause());
    });
    return;
  }
  const prev = root.querySelector('.v20-video-prev');
  const next = root.querySelector('.v20-video-next');
  const count = root.querySelector('.v20-video-count');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let current = 0, settling, centering = false, centerTimer;
  function nearest() {
    const middle = track.getBoundingClientRect().left + track.clientWidth / 2;
    return cards.reduce((best, card, i) => {
      const rect = card.getBoundingClientRect();
      const other = cards[best].getBoundingClientRect();
      return Math.abs(rect.left + rect.width / 2 - middle) < Math.abs(other.left + other.width / 2 - middle) ? i : best;
    }, 0);
  }
  function update(i) {
    current = i;
    cards.forEach((card, n) => card.classList.toggle('is-current', n === i));
    prev.disabled = i === 0;
    next.disabled = i === cards.length - 1;
    count.textContent = `${i + 1} / ${cards.length}`;
  }
  function center(i, alignPage = false, instant = false) {
    if (matchMedia("(min-width:1000px)").matches) { track.scrollLeft = 0; return; }
    clearTimeout(centerTimer);
    centering = true;
    update(i);
    const rect = cards[i].getBoundingClientRect();
    const viewport = track.getBoundingClientRect();
    const behavior = instant || reduced.matches ? 'instant' : 'smooth';
    track.scrollTo({left: track.scrollLeft + rect.left - viewport.left - (track.clientWidth - rect.width) / 2, behavior});
    if (alignPage) window.scrollTo({top: Math.max(0, window.scrollY + rect.top - (window.innerHeight - rect.height) / 2), behavior});
    centerTimer = setTimeout(() => { centering = false; }, 650);
  }
  function navigate(i) {
    videos.forEach(video => video.pause());
    center(Math.max(0, Math.min(cards.length - 1, i)));
  }
  prev.addEventListener('click', () => navigate(current - 1));
  next.addEventListener('click', () => navigate(current + 1));
  track.addEventListener('keydown', e => {
    if (e.target !== track) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault(); navigate(current + (e.key === 'ArrowRight' ? 1 : -1));
    }
  });
  videos.forEach((video, i) => video.addEventListener('play', () => {
    videos.forEach(other => { if (other !== video) other.pause(); });
    center(i, true);
  }));
  track.addEventListener('scroll', () => {
    clearTimeout(settling);
    settling = setTimeout(() => {
      if (centering || matchMedia("(min-width:1000px)").matches) return;
      const i = nearest();
      videos.forEach((video, n) => { if (n !== i) video.pause(); });
      update(i);
    }, 140);
  }, {passive:true});
  window.addEventListener('resize', () => center(current, false, true));
  document.addEventListener('visibilitychange', () => { if(document.hidden) videos.forEach(video => video.pause()); });
  requestAnimationFrame(() => center(0, false, true));
})();

}
document.querySelectorAll('[data-creator-carousel]').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-creator-carousel]').forEach(init));
})();
